import { post, get } from '../../../components/hooks/apiFetch';
import { handleApiError } from '../../../utils/errorHandlerUtils';

export const useStandardControlPSAApi = () => {
    const submitStandardControlPSARequest = async (filesWithFormats, promptText, comment = '', startTime = '') => {
        comment ??= '';
        const formData = new FormData();
        filesWithFormats.forEach((item, index) => {
            formData.append(`Files[${index}].File`, item.file, item.file.name);
            formData.append(`Files[${index}].OutputFormat`, item.outputFormat);
            if (item.templateName && item.templateName.trim() !== '') {
                formData.append(`Files[${index}].TemplateName`, item.templateName);
            }
        });

        formData.append('Options.PromptText', promptText.trim());
        formData.append("Options.Comment", comment.trim());
        formData.append("Options.StartTime", startTime);

        const response = await post(`/api/standardcontrolpsa`, formData);

        if (!response.ok) {
            throw await handleApiError(response);
        }

        const result = await response.json();

        return {
            id: result.id,
            identifier: result.identifier
        };
    };

    const cancelStandardControlPSATask = async (inputIdentifier) => {
        await get(`/api/standardcontrolpsa/cancel/${encodeURIComponent(inputIdentifier)}`);
        return true;
    };

    return { submitStandardControlPSARequest, cancelStandardControlPSATask };
};